import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, Box, darken, Typography } from '@mui/material';

var _excluded = ["pickerValue", "pickerState", "pickerEvents", "children", "className"];

var getDefaultPickerContent = function getDefaultPickerContent(value, state) {
  var files = Array.isArray(value) ? value : !!value ? [value] : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, files.map(function (f, i) {
    return /*#__PURE__*/React.createElement(Typography, {
      key: "".concat(i, "-").concat(f.name),
      fontWeight: "bold",
      mb: 1
    }, f.name);
  }), /*#__PURE__*/React.createElement(Typography, null, files.length > 0 ? "Drag and drop ".concat(state.multiple ? "files" : "a file", " here to replace") : "Drag and drop ".concat(state.multiple ? "files" : "a file", " here or click to browse")));
};

var DropzoneBox = styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "dragActive" && prop !== "dragRejecting" && prop !== "borderColor" && prop !== "borderWidth" && prop !== "disabled";
  }
})(function (_ref) {
  var theme = _ref.theme,
      dragActive = _ref.dragActive,
      dragRejecting = _ref.dragRejecting,
      bgcolor = _ref.bgcolor,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? dragRejecting ? theme.palette.error.main : theme.palette.primary.main : _ref$borderColor,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 2 : _ref$borderWidth,
      disabled = _ref.disabled;
  var stroke = (disabled ? theme.palette.grey[600] : borderColor).replace("#", "%23");
  var strokeWidth = typeof borderWidth === "number" ? borderWidth + "px" : borderWidth;
  var borderImage = "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='".concat(stroke, "' stroke-width='").concat(strokeWidth, "' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")");
  return {
    padding: theme.spacing(2, 3),
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: disabled ? "default" : dragRejecting ? "no-drop" : "pointer",
    backgroundColor: disabled ? theme.palette.grey[200] : bgcolor !== undefined ? undefined // pass through to box background
    : dragActive ? darken(theme.palette.background.paper, 0.05) : theme.palette.background.paper,
    color: disabled ? theme.palette.grey[500] : undefined,
    "&:before": {
      content: "' '",
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundImage: borderImage
    }
  };
});

var FilePickerDropzone = function FilePickerDropzone(_ref2) {
  var pickerValue = _ref2.pickerValue,
      pickerState = _ref2.pickerState,
      pickerEvents = _ref2.pickerEvents,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? getDefaultPickerContent : _ref2$children,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);

  var dragActive = pickerState.dragActive,
      dragAccepting = pickerState.dragAccepting,
      dragRejecting = pickerState.dragRejecting;
  return /*#__PURE__*/React.createElement(DropzoneBox, _extends({}, props, {
    dragActive: dragActive,
    dragRejecting: dragRejecting,
    disabled: pickerState.disabled,
    className: classnames(className, {
      active: dragActive,
      accepting: dragAccepting,
      rejecting: dragRejecting
    })
  }), typeof children === "function" ? children(pickerValue, pickerState, pickerEvents) : children);
};

FilePickerDropzone.propTypes = {
  borderColor: propTypes.string,
  borderWidth: propTypes.oneOfType([propTypes.number, propTypes.string])
};
var FilePickerDropzone$1 = FilePickerDropzone;

export { FilePickerDropzone$1 as default };
